// removed by extract-text-webpack-plugin
module.exports = {"Form_wrap":"CreateUser__Form_wrap__zCwnU","Form_group":"CreateUser__Form_group__zBTl0","Form_radio":"CreateUser__Form_radio__1eN96","ContainerBtn":"CreateUser__ContainerBtn__2A2RQ","Btn":"CreateUser__Btn__3hQeo","RedBtn":"CreateUser__RedBtn__1Vca4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserController/CreateUser/CreateUser.css
// module id = 102
// module chunks = 0